<template>
  <div class="wrapper">
    <div class="dd2">
      <iframe style="width:100%;height:100%;" :src="url" frameborder="0" scrolling="no" id="bdIframe">
      </iframe>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: '',
    };
  },
  mounted() {
    this.url = '../static/download/healthDBAPdf.pdf';
  },
}
</script>
<style>
#content {
  width: 100%;
  height: 100%
}

.wrapper {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 10px;
  bottom: 20px;
  padding-top: 10px;
}

.dd2 {
  height: 100%;
}

iframe {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/pdf/healthDBAPdf.vue